import React from 'react';
import "./SuccessProgressSteps.scss";

interface ProgressStepsProps {
    currentStep?: number;
    labels?: [string, string, string];
}

export default function SuccessProgressSteps({ currentStep = 2, labels = ['Text 1', 'Text 2', 'Text 3'] }: ProgressStepsProps) {
    const steps = [1, 2, 3];

    return (
        <div className="progress-steps" role="group" aria-label="Progress">
            {steps.map((s, idx) => {
                const state = s < currentStep ? 'completed' : s === currentStep ? 'current' : 'pending';
                return (
                    <React.Fragment key={s}>
                        <div className={`step step--${state}`}>
                            <div className="step__icon" aria-hidden="true">
                                {state === 'completed' && (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="#28a745" />
                                        <path d="M7 12.5l3 3 7-8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                                {state === 'current' && (
                                    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" role="img">
                                        <circle cx="12" cy="12" r="10" fill="#fdb022" />
                                        <circle cx="12" cy="12" r="8" fill="#ffffff" />
                                        <circle cx="12" cy="12" r="5" fill="#fdb022" />
                                    </svg>
                                )}
                                {state === 'pending' && (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="#cfcfcf" />
                                    </svg>
                                )}
                            </div>
                            <div className="step__label">{labels[idx]}</div>
                        </div>

                        {idx < steps.length - 1 && (
                            <div
                                className={`connector ${idx < currentStep - 1 ? 'connector--active' : 'connector--inactive'}`}
                                aria-hidden="true"
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}